import * as React from 'react'

import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
// import { Separator } from '@thg-commerce/gravity-elements'
import { TextStyling } from '@thg-commerce/gravity-patterns'
import { margin } from '@thg-commerce/gravity-theme'

import { SizeGuideModal } from '../Modal/SizeGuideModal'
import { SizeGuideTrigger } from '../SizeGuideTrigger'

export interface SizeGuideContainerProps {
  sizeGuide?: string
  hasMarginBottom?: boolean
  modalLinkTextStyling?: TextStyling

  table?: {
    head?: {
      backgroundColor?: string
      color?: string
    }
  }
}

export const SizeGuideContainer = (props: SizeGuideContainerProps) => {
  const theme = useTheme()
  const { hasShoeSizeMeId } = useSiteConfig()
  const i18nText = {
    closeI18nText: {
      closeAriaLabel: i18n('general.modal.close.button.arialabel'),
      closeLabel: i18n('general.modal.close.button.label'),
    },
    title: i18n('product.sizeguide.heading.text'),
  }

  const [sizeGuideModalOpen, setSizeGuideModalOpen] = React.useState(false)

  if (!props.sizeGuide) {
    return null
  }

  return (
    <div
      style={
        hasShoeSizeMeId && theme.pageTheme.sizeGuide.alternateMargin
          ? { margin: theme.pageTheme.sizeGuide.alternateMargin }
          : { marginBottom: props.hasMarginBottom ? '20px' : '0' }
      }
    >
      <SizeGuideTrigger
        textStyling={props.modalLinkTextStyling}
        i18nText={{ triggerText: i18nText.title }}
        onClick={() => {
          setSizeGuideModalOpen(true)
        }}
        svg={theme.icons?.sizeGuide}
      />
      {sizeGuideModalOpen && (
        <SizeGuideModal
          i18nText={i18nText}
          onClose={() => {
            setSizeGuideModalOpen(false)
          }}
          content={props.sizeGuide}
        />
      )}
      {/* <Separator withSpacing /> */}
    </div>
  )
}
